<template>
	<div class="row">
		<div class="col-12">
			<div class="box">
				<StallionNotes :horse_id="horse_id" />
			</div>
		</div>
		<div class="col-12 mt-2">
			<div class="box">
				<h2>{{ $t('monte.congelation.proprietaire_stallion') }}</h2>
				<div v-for="tiers in tiers_horse" :key="tiers.tiershorse_id" class="mb-2">
					{{ tiers.tiers.tiers_rs }}
				</div>
				<h2>{{ $t('horse.tiers_secondaires') }}</h2>
				<div v-for="tiers in secondaires" :key="tiers.tiershorse_id">
					{{ tiers.tiers.tiers_rs }} - {{ getTrad(tiers.fonction.fonction_label) }}
				</div>
			</div>
		</div>
		<div class="col-12 mt-2">
			<div class="box">
				<StallionStocksNormes :horse_id="horse_id" />
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"
    import Horse from "@/mixins/Horse.js"
    import Tiers from "@/mixins/Tiers.js"

	export default {
		name: 'StallionDashboard',
		mixins: [Congelation, Horse, Tiers],
		props: ['horse_id'],
		data () {
			return {
				loading: false,
				tiers_horse: [],
				secondaires: []
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.loading = true
				const tiers = await this.loadTiersHeavyCurrentPart(this.horse_id, true)
				this.tiers_horse = tiers.filter(tier => !tier.zero)
				this.secondaires = await this.loadTiersHorseSecondaires(this.horse_id)
				this.loading = false
			},

			formatMonth(month) {
				const split = month.split('_')
				return this.getTrad("mois."+parseInt(split[0], 10)) +" "+ split[1]
			}
		},

		components: {
			StallionNotes: () => import('@/components/Congelation/StallionNotes'),
			StallionStocksNormes: () => import('@/components/Congelation/StallionStocksNormes')
		}
	}

</script>